<template>
  <q-page class="main">
    <common-form :action="$route('user.role.update', {rol: role.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Rol aanpassen</h1>
          <role-form :role="role" :permissions="permissions" :permission_ids="permission_ids"/>
        </q-card-section>
        <q-separator />
        <q-card-actions
            class="page-card__actions justify-between"
        >
          <warning-button label="Verwijder rol" @click="onDeleteClick"/>
          <accent-button label="Opslaan" type="submit"/>
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import RoleForm from './RoleForm'

export default {
  components: {
    RoleForm
  },
  props: {
    role: {
      type: Object,
      default: null
    },
    roles: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Array,
      default: () => []
    },
    permission_ids: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    async onDeleteClick () {
      if (!await this.$confirm(
          {
            title: 'Rol verwijderen',
            messages: ['Weet u zeker dat u deze rol wilt verwijderen? Dit kan niet ongedaan worden gemaakt.']
          }
      )) {
        return
      }
      this.$goto('user.role.destroy', {role_id: this.role.id});
    },
  }
}
</script>
